<template>
  <div class="sidebar">
    <div class="tab" v-for="(tab, index) in tabs" :key="index"
      :class="{ 'selected' : tab.label === currentTab.label }"
      :tabindex="tab.tabindex" @click.stop="switchTab(tab)"
      @keydown.enter.space.stop="switchTab(tab)" style="outline: none; cursor: pointer;">
      <svg-icon v-if="tab.label === currentTab.label"
        :name="`${tab.iconName}-active`"></svg-icon>
      <svg-icon v-else :name="`${tab.iconName}-inactive`"></svg-icon>
      <span>{{ tab.label }}</span>
      <guide-popup v-if="tab.label === currentTab.label"
        :tab-index="index"
        @next="nextGuideTab(index)"></guide-popup>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SideBar',
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      currentTab: state => state.currentTab,
      contactInfo: state => state.contactInfo,
      isUserGuide: {
        get() {
          return this.$store.state.isUserGuide;
        },
        set(value) {
          this.$store.commit('IS_USER_GUIDE_CHANGED', value);
        }
      },
      userInfo: state => state.userInfo
    }),
    tabs() {
      return window.siderBarTabs;
    }
  },
  methods: {
    switchTab(tab) {
      if (this.currentTab.label !== tab.label) {
        this.$store.commit('CURRENT_TAB_CHANGED', tab);
        this.$router.push({name: tab.label});
      }
    },
    nextGuideTab(index) {
      if (this.currentTab.label === 'Closed Programs') {
        this.$store.commit('IS_USER_GUIDE_CHANGED', false);
        this.switchTab(this.tabs[0]);
        if (this.contactInfo.isCOVIDAvailable || this.contactInfo.isDACAGrantAvailable || this.contactInfo.isDACALoanAvailable || this.contactInfo.isIFRPAvailable || this.contactInfo.isIFRPLoanAvailable || this.contactInfo.isMIJAGrantAvailable) {
          this.$store.commit('IS_CUSTOM_POPUP_CHANGED', true);
        }
      } else {
        this.switchTab(this.tabs[index + 1]);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.sidebar {
  float: left;
  width: $sidebar-width;
  @include inline-flex-col;

  @media screen and (max-width: $max-width-phone) {
    display: none;
  }

  .tab {
    margin: 5px 0;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    height: 50px;
    @include inline-flex-row;
    align-items: center;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    transition: all 200ms linear;
    color: $font-color-tab;

    .icon {
      margin-right: 10px;
      &:hover {
        cursor: pointer;
      }
    }

    span {
      flex: 1;
      &:hover {
        cursor: pointer;
      }
    }
  }

  .selected {
    color: $font-color-white;
    background-color: $tab-active;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/SideBar.vue